// extracted by mini-css-extract-plugin
export var button = "B_5";
export var menu = "B_ch";
export var menuButton = "B_b0";
export var readerToolbar = "B_cf";
export var tooltip = "B_cg";